import { Component, OnInit } from '@angular/core';
import { InvoiceCashDeskService } from '../../../services/invoice-cash-desk/invoice-cash-desk.service';
import { InvoicePatientCashDeskService } from '../../../services/invoice-cash-desk/invoice-patient-cash-desk.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'invoice-patient-cash-desk-view',
  templateUrl: './invoice-patient-cash-desk-view.component.html',
  providers: [{ provide: InvoiceCashDeskService, useClass: InvoicePatientCashDeskService }]
})
export class InvoicePatientCashDeskViewComponent implements OnInit {

  invoiceId: number;
  appointmentId?: number;

  constructor(private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.route.params.subscribe(async params => {
      this.invoiceId = params['CashDeskInvoiceId'];
      this.appointmentId = params['AppointmentId'];
    });
  }

  close(): void {
    history.back();
  }
}
